import { Icon } from 'src/assets/svg/Icon'
import styled, { css } from 'styled-components'
import React from 'react'

import {
  Noto_body2_b14,
  Noto_desc_b10,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import closed_btn_button_bg from 'src/assets/images/main/closed_wallet_btn.png'
import Marquee from 'react-fast-marquee'
import { BottomSheetProps } from 'src/components/layout/MainLayout/MainBottomSheet'
import { bottomOutPageTransitionProps } from 'src/styles/animation'
import { Container } from 'src/components/common/Container'
import { ZIndex } from 'src/styles/mixin'

const MainBottomSheetClosed = ({ closedBottomSheetContents }: BottomSheetProps) => {
  const { chips, button, primary } = closedBottomSheetContents

  return (
    <Container
      $option="flex_row_space_between"
      $style={S.MainBottomClosedContainer}
      $column_gap="20px"
      {...bottomOutPageTransitionProps}
    >
      <Container $option="flex_column" $row_gap="2px" $style={S.MainBottomClosedContent}>
        <S.MainBottomClosedChips $color={chips.color}>{chips.text}</S.MainBottomClosedChips>
        <S.MainBottomClosedPrimaryMarquee speed={30}>{primary}</S.MainBottomClosedPrimaryMarquee>
      </Container>
      <S.MainBottomClosedPrimaryButton onClick={button.func}>
        <Icon.ClosedWalletBtnBarcode />
        {button.text}
      </S.MainBottomClosedPrimaryButton>
    </Container>
  )
}

export default MainBottomSheetClosed
const S = {
  MainBottomClosedContainer: css`
    position: fixed;
    bottom: 16px;
    flex-flow: row nowrap;
    align-items: center;
    width: calc(100% - 20px);
    background-color: var(--black-90);
    border-radius: 12px;
    padding: 14px;
    z-index: ${ZIndex.BottomSheet};
    max-width: 500px;
    min-width: 280px;
  `,
  MainBottomClosedContent: css`
    height: 46px;
  `,
  MainBottomClosedChips: styled.section<{ $color: string }>`
    display: flex;
    width: fit-content;
    color: ${(props) => props.$color};
    background-color: var(--black-70);
    padding: 2px 8px;
    border-radius: 100px;
    ${Noto_desc_b10};
  `,
  MainBottomClosedPrimaryMarquee: styled(Marquee)`
    color: var(--white);
    ${Noto_body2_b14};
  `,
  MainBottomClosedPrimaryButton: styled.button`
    width: 140px;
    min-width: 140px;
    height: 46px;
    background: url(${closed_btn_button_bg}) no-repeat center/contain;
    ${Noto_subheading_b18};
    color: var(--white);
    display: flex;
    align-items: center;
    gap: 3px;
    justify-content: space-between;
    padding: 0 14px 0 24px;
  `,
}
